const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    basename: "",
    defaultPath: "/",
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 12,
    outlinedFilled: true,
    theme: "light", // light, dark
    presetColor: "theme7", // default, theme1, theme2, theme3, theme4, theme5, theme6, theme7
    i18n: undefined // 'en' - English, 'de' - German
};

export default config;
